export const CUSTOMER_TYPE_OPTIONS = [
  {
    label: "Online Seller (Flipkart/Amazon/Meesho)",
    value: "Online Seller (Flipkart/Amazon/Meesho)",
  },
  { label: "Retail Shop Owner", value: "Retail Shop Owner" },
  { label: "Wholesale Buyer", value: "Wholesale Buyer" },
  { label: "Individual", value: "Individual" },
];

export const INQUIRY_TYPES = [
  { label: "General Inquiry", value: "GENERAL_ENQUIRY" },
  { label: "Wholesale / Bulk Order", value: "WHOLESALE_BULK_ORDER" },
  { label: "Order Status", value: "ORDER_STATUS" },
  { label: "Product Information", value: "PRODUCT_INFORMATION" },
  { label: "Other", value: "OTHER" },
];

export const PLATFORM_OPTIONS = [
  { label: "Flipkart Seller", value: "Flipkart" },
  { label: "Amazon Seller", value: "Amazon" },
  { label: "Meesho Reseller", value: "Meesho" },
  { label: "Myntra Seller", value: "Myntra" },
  { label: "Retail Shop Owner", value: "Retail" },
  { label: "Own Website", value: "Website" },
  { label: "WhatsApp Reseller", value: "WhatsApp" },
  { label: "Other", value: "Other" },
];

export const ESTIMATED_BUDGET_OPTIONS = [
  { label: "Below ₹25,000", value: "Below 25k" },
  { label: "₹25,000 – ₹50,000", value: "25k-50k" },
  { label: "₹50,000 – ₹1,00,000", value: "50k-1L" },
  { label: "₹1,00,000 – ₹5,00,000", value: "1L-5L" },
  { label: "₹5,00,000 +", value: "Above 5L" },
];

export const ESTIMATED_ORDER_PIECE_OPTIONS = [
  { label: "1-100", value: "1-100" },
  { label: "100-200", value: "100-200" },
  { label: "200-500", value: "200-500" },
  { label: "500-1000", value: "500-1000" },
  { label: "1000+", value: "1000+" },
];

export const ORDER_STATUS_OPTIONS = [
  { label: "Pending", value: "Pending" },
  { label: "Confirmed", value: "Confirmed" },
  { label: "Shipped", value: "Shipped" },
  { label: "Delivered", value: "Delivered" },
  { label: "Cancelled", value: "Cancelled" },
];

export const PAYMENT_STATUS_OPTIONS = [
  { label: "Pending", value: "Pending" },
  { label: "Partially Paid", value: "Partially Paid" },
  { label: "Paid", value: "Paid" },
  { label: "Failed", value: "Failed" },
];

export const GST_RATE_SLAB = [
  { label: "Nill", value: 0 },
  { label: "3%", value: 3 },
  { label: "5%", value: 5 },
  { label: "12%", value: 12 },
  { label: "18%", value: 18 },
  { label: "40%", value: 40 },
];
